import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../config';

import FontCustom from '../../../components/Content/FontCustom';

function AppAdvantages({ isFullSize }) {
    const mdSize = isFullSize ? 3 : 6;
    const xsSize = 6; // isFullSize ? 6 : 12;
    return (
        <Row noGutters className="text-black-50">
            <Col xs={xsSize} md={mdSize} lg="3" className="d-flex justify-content-center mb-2">
                <FontCustom name="europe" size="3x" className="pr-2 pt-1" /> <span style={{ maxWidth: '6rem' }}><FormattedMessage id="appAdvantagesFabrication" defaultMessage="Made in Europe" /></span>
            </Col>
            <Col xs={xsSize} md={mdSize} lg="3" className="d-flex justify-content-center mb-2">
                <FontCustom name="livraison" size="3x" className="pr-2 pt-1" /> <span style={{ maxWidth: '6rem' }}><FormattedMessage id="appAdvantagesFreeShipping" defaultMessage="Free shipping in Europe" />*</span>
            </Col>
            <Col xs={xsSize} md={mdSize} lg="3" className="d-flex justify-content-center mb-2">
                <FontCustom name="world" size="3x" className="pr-2 pt-1" /> <span style={{ maxWidth: '6rem' }}><FormattedMessage id="appAdvantagesInternationalShipping" defaultMessage="International shipping" /></span>
            </Col>
            <Col xs={xsSize} md={mdSize} lg="3" className="d-flex justify-content-center mb-2">
                <FontCustom name="credit-card" size="3x" className="pr-2 pt-1" /> <span style={{ maxWidth: '6rem' }}><FormattedMessage id="appAdvantagesSecurePayment" defaultMessage="100% secure payment" /></span>
            </Col>
        </Row>
    );
}

AppAdvantages.defaultProps = {
    isFullSize: false,
};

AppAdvantages.propTypes = {
    isFullSize: PropTypes.bool,
};

export default AppAdvantages;
